import { ElementHTML, getPhotos, getVideos } from '@helpers/helper.rendering'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  setCurrentlyBlueprint,
  setCurrentlyImage,
  setTogglerBlueprints,
  setTogglerImages,
  setTogglerTours,
  setTogglerVideos,
} from '@slices/galerySlice'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { RealEstateDataPageComponentData, StateGallerySlice } from 'types'
import Gallery from '@components/fsLightboxGallery'
import { getBluePrints, getTours } from '@helpers/helper.properties'

//Helpers
const PropertyAmenities6 = ({
  propertyID,
  developmentID,
  global_data,
  titleHexa,
  title,
  titleElement,
  multimediaItem,
  backgroundHexa,
}: {
  propertyID: string
  developmentID: string
} & RealEstateDataPageComponentData) => {
  const tokkoKey = global_data.pageConfig.keys.tokko
  const { data } = propertyID
    ? useQueryProperty(propertyID, tokkoKey)
    : useQueryDevelopment(developmentID, tokkoKey)

  //   const {
  //     togglerVideos,
  //     togglerImages,
  //     togglerTours,
  //     togglerBlueprints,
  //     currentlyImage,
  //     currentlyBluePrint,
  //   } = useSelector((state: { gallery: StateGallerySlice }) => state.gallery)!

  const dispatch = useDispatch()
  const toggleGallery = () => {
    // switch (active) {
    //   case 'video':
    //     return dispatch(setTogglerVideos())
    //   case 'image':
    //     return dispatch(setTogglerImages())
    //   case 'tour':
    //     return dispatch(setTogglerTours())
    //   case 'blueprint':
    //     return dispatch(setTogglerBlueprints())
    // }
    return true
  }
  const functionGalleryFotos = () => {
    dispatch(setCurrentlyImage(1))
    dispatch(setTogglerImages())
    toggleGallery()
  }

  const functionGalleryVideos = () => {
    dispatch(setTogglerVideos())
    toggleGallery()
  }
  const functionGalleryTours = () => {
    dispatch(setTogglerTours())
    toggleGallery()
  }
  const functionGalleryBlueprints = () => {
    dispatch(setCurrentlyBlueprint(1))
    dispatch(setTogglerBlueprints())
    toggleGallery()
  }

  return (
    <section className="p-y-config summary-gallery a">
      {/* {getVideos(data?.videos).length > 0 ? (
        <Gallery
          index={1}
          sources={getVideos(data?.videos)}
          slide={1}
          type={'video'}
          toggleEvent={togglerVideos}
          data={data}
        />
      ) : null}
      {getPhotos(data?.photos).length > 0 ? (
        <Gallery
          index={2}
          sources={getPhotos(data?.photos)}
          slide={currentlyImage}
          type={'image'}
          toggleEvent={togglerImages}
          data={data}
        />
      ) : null}
      {getTours(data).length > 0 ? (
        <Gallery
          index={3}
          sources={getTours(data)}
          slide={1}
          type={'tour'}
          toggleEvent={togglerTours}
          data={data}
        />
      ) : null}
      {getBluePrints(data).length > 0 ? (
        <Gallery
          index={4}
          sources={getBluePrints(data)}
          slide={currentlyBluePrint}
          type={'blueprint'}
          toggleEvent={togglerBlueprints}
          data={data}
        />
      ) : null} */}
      <Container fluid>
        <Row>
          <Col lg={12}>
            <ElementHTML
              elementType={titleElement || 'h2'}
              className="mb-lg-4"
              style={{ color: titleHexa || '#1f1f1f' }}
              children={title || 'Multimedia'}
            />
          </Col>
          {getPhotos(data)?.length !== 0 && (
            <Col
              lg={10}
              className="d-flex"
            >
              <div
                style={{ backgroundColor: backgroundHexa || '#1f1f1f' }}
                className="card-multimedia"
                onClick={() => dispatch(setTogglerImages())}
              >
                {multimediaItem?.image_photos && (
                  <img
                    src={multimediaItem?.image_photos}
                    alt=""
                  />
                )}

                <p>Fotos</p>
              </div>
              {getBluePrints(data)?.length !== 0 && (
                <div
                  style={{ backgroundColor: backgroundHexa || '#1f1f1f' }}
                  className="card-multimedia ms-4"
                  onClick={() => dispatch(setTogglerBlueprints())}
                >
                  {multimediaItem?.image_blueprints && (
                    <img
                      src={multimediaItem?.image_blueprints}
                      alt=""
                    />
                  )}

                  <p>Planos</p>
                </div>
              )}
              {getVideos(data?.videos)?.length !== 0 && (
                <div
                  style={{ backgroundColor: backgroundHexa || '#1f1f1f' }}
                  className="card-multimedia ms-4"
                  onClick={() => dispatch(setTogglerVideos())}
                >
                  {multimediaItem?.image_youtube && (
                    <img
                      src={multimediaItem?.image_youtube}
                      alt=""
                    />
                  )}
                  <p>Videos</p>
                </div>
              )}
              {getTours(data)?.length !== 0 && (
                <div
                  style={{ backgroundColor: backgroundHexa || '#1f1f1f' }}
                  className="card-multimedia ms-4"
                  onClick={() => dispatch(setTogglerTours())}
                >
                  {multimediaItem?.image_tours && (
                    <img
                      src={multimediaItem?.image_tours}
                      alt=""
                    />
                  )}

                  <p>Tours</p>
                </div>
              )}
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default PropertyAmenities6
